// extracted by mini-css-extract-plugin
export default {"miniScreen":"BY9zN","header":"Cig8V","body":"xK7As","footer":"EYWFo"};